import breakpoints, {
  maxBreakpoints, maxBreakpointsPx
} from "./breakpoints/breakpoints";
import MediaQueryGenerator from "./MediaQueryGenerator/MediaQueryGenerator";

const media = new MediaQueryGenerator(breakpoints, maxBreakpoints, maxBreakpointsPx);
export default media;
